import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CarritoService } from 'src/app/services/carrito.service';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
})
export class SuccessComponent implements OnInit {

 constructor(
    private route: ActivatedRoute,
    private carrito: CarritoService,
    private router: Router
  ) {}

  ngOnInit() {
    const pagoOk = this.route.snapshot.queryParamMap.get('success');

    if (pagoOk === 'true') {
      this.carrito.clearCart();
    }
  }

  goHome() {
    this.router.navigate(['/home']);
  }

}
